import { render } from "./ImportShgs.vue?vue&type=template&id=60da6dd5&scoped=true"
import script from "./ImportShgs.vue?vue&type=script&lang=js"
export * from "./ImportShgs.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60da6dd5"]])

export default __exports__